import React from 'react';
import { WizardContextType } from "./Wizard.types";

const WizardContext = React.createContext<WizardContextType | undefined>(undefined);

export default WizardContext;
